import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, applyDialplanSystem, internalDialplan, exportSelectAllQueues, exportSelectAllEndpoints } from '../../../services';
import FormInternalCalls from './components/formIpSetDialPlanInternal';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function DialplanInternalCalls() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElementsActive, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [values, setValues] = useState({
    internal: {
      only: false,
      mask: "",
      timeout: 0,
      overflow: "",
      redirect: {
        type: "",
        destination: "",
        overflowData: {
          typeOverFlow: "",
          destinationOverflow: ""
        }
      }
    }
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [resultMessage, setResultMessage] = useState({});
  const [inputDisable, setinputDisable] = useState(false);
  const [queues, setQueues] = useState([]);
  const [endpoints, setEndpoints] = useState([]);
  const [toggleOverflowRedirect, setToggleOverflowRedirect] = useState('');

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    
    const queuesList = await exportSelectAllQueues();
    if(queuesList === undefined) setLoading(true);
    const fetchedQueues = queuesList.map((element) => element.queuesselect);
    setQueues(fetchedQueues);

    const endpointsList = await exportSelectAllEndpoints();
    if(endpointsList === undefined) setLoading(true);
    const fetchedEndpoints = endpointsList.map((element) => element.endpoint).filter((element) => !isNaN(Number(element)));
    setEndpoints(fetchedEndpoints);
    
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(!check, `${name}-placeholder-data`);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isQuadChar } = valuesAnalyze;

    let checkValueIsCharacters = false;
    
    const redirectType = values.internal.redirect.type;
    const redirectOverflowType = values.internal.redirect.overflowData.typeOverFlow;

    if (name === 'mask') checkValueIsCharacters = Number(value.length) >= 4 && isQuadChar(value) ? true : false;
    if (name === 'only') checkValueIsCharacters = typeof value !== 'boolean' ? true : false;
    if (name === 'timeout') checkValueIsCharacters = Number(value) >= 5 && Number(value) <= 120 && valuesAnalyze.checkNumber(Number(value)) ? true : false;
    if (name === 'overflow') checkValueIsCharacters = value === 'yes' || value === 'no' ? true : false;
    if (name === 'redirect-overflowData-typeOverFlow') checkValueIsCharacters = isNaN(value) ? true : false;
    if (name === 'redirect-destination' && redirectType === 'endpoint') checkValueIsCharacters = checkNumber(Number(value)) ? true : false;
    if (name === 'redirect-destination' && redirectType === 'queue') checkValueIsCharacters = isNaN(Number(value)) ? true : false;
    if (name === 'redirect-overflowData-destinationOverflow' && redirectOverflowType === 'endpoint') checkValueIsCharacters = !isNaN(Number(value)) ? true : false;
    if (name === 'redirect-overflowData-destinationOverflow' && redirectOverflowType === 'queue') checkValueIsCharacters = isNaN(Number(value)) ? true : false;

    changeScreen(checkValueIsCharacters, name);

    return checkValueIsCharacters;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);

    setValidate((prevState) => {
      let nameTmp = values.internal.overflow;
      
      const vld = validate[name] = itemStatus === undefined  ? true : itemStatus
      if (name === 'overflow') nameTmp = value;
      if (Object.keys(prevState).length === 4 && nameTmp === 'no' && !Object.values(prevState).includes(false)) setDisable(false);
      if (Object.keys(prevState).length < 6 && nameTmp === 'yes' && !Object.values(prevState).includes(false)) setDisable(true);
      if (Object.keys(prevState).length === 6 && !Object.values(prevState).includes(false) && nameTmp === 'yes') setDisable(false);

      return { ...prevState, ...vld }
    });

    let nameList = []

    // setValues((prevState) => prevState, values['internal'][name] = value);
    name.includes('-') ? nameList = name.split('-') : setValues((prevState) => prevState, values['internal'][name] = value);
    if (name === 'only') setValues((prevState) => prevState, values['internal'][name] = value === 'true');
    if (nameList.length === 2) setValues((prevState) => prevState, values['internal']['redirect'][nameList[1]] = value);
    if (nameList.length === 3) setValues((prevState) => prevState, values['internal']['redirect']['overflowData'][nameList[2]] = value);
    
    if (name === 'redirect-overflowData-typeOverFlow') {
      setToggleOverflowRedirect('overflow-' + value)
      if (toggleOverflowRedirect !== '') toggleIsHidden(`#${toggleOverflowRedirect}`);
      if ('overflow-' + value !== '') toggleIsHidden(`#overflow-${value}`);
    }

    if (name === 'only') setValues((prevState) => prevState, values['internal'][name] = value === 'true');
    if (name === 'mask') setValues((prevState) => prevState, values['internal'][name] = value.toUpperCase());

    if (name === 'overflow' && value === 'yes' && values.internal.overflow === 'yes') toggleIsChangeFormElements('columns-overflow', 'columns mx-2 is-mobile is-active');
    if (name === 'overflow' && value === 'no' && values.internal.overflow === 'no') toggleIsChangeFormElements('columns-overflow', 'columns mx-2 is-mobile is-hidden');

    return;
  };

  const sendDataDialplanInternal = async () => {
    // const sendInternalDilaplan = await internalDialplan(values);
    console.log(values);
    // const result = sendInternalDilaplan.message.includes('sucesso') ? true : false;

    if(result) {
      toggleIsHidden('#button-send-form');
      toggleIsHidden('#alert-create-call-internal');
      toggleIsHidden('#button-send-apply');
      setinputDisable(true);
      return;
    };
    return toggleIsHidden('#alert-error-call-internal');
  };

  const sendApplyConfig = async () => {
    const apply = await applyDialplanSystem();
    setResultMessage(apply.data);
    
    toggleIsHidden('#alert-create-call-internal');
    toggleIsHidden('#alert-return-call-internal');
    toggleIsHidden('#button-send-apply');
    toggleIsHidden('#form-entrace');

    setTimeout(() => {
      return window.location.reload(true)
    }, 3000);
  };


  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      <div className="columns has-text-centered">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">CHAMADAS INTERNAS</strong>
          <hr className="dropdown-divider"/>
        </div>
      </div>
      <article id="alert-error-call-internal" name="alert-error-call-internal" className="column is-half is-offset-one-quarter message is-danger is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-error-call-internal');
            setinputDisable(false);
          }}></button>
        </div>
        <div className="message-body">
          Não foi possível adicionar a configuração!
          <br />
        </div>
      </article>
      <article id="alert-create-call-internal" name="alert-create-call-internal" className="column is-half is-offset-one-quarter message is-info is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-create-call-internal');
            toggleIsHidden('#button-send-form');
            toggleIsHidden('#button-send-apply');
            setinputDisable(false);
          }}></button>
        </div>
        <div className="message-body">
          Para as configurações serem aplicadas será necessário clicar no botão <strong>Aplicar</strong> abaixo.
          <br />
        </div>
      </article>
      <article id="alert-return-call-internal" name="alert-create-call-internal" className="column is-half is-offset-one-quarter message is-link is-hidden">
        <div className="message-header">
          <p>Atenção!</p>
          <button className="delete" aria-label="delete" onClick={ () => {
            toggleIsHidden('#alert-return-call-internal');
            toggleIsHidden('#button-send-apply');
          }}></button>
        </div>
        <div className="message-body">
          { resultMessage.message }
          <br />
        </div>
      </article>
      <div id="form-entrace" className="column is-full is-offset-one-quarter has-text-centered">
        <FormInternalCalls handleChangeValues={ handleChangeValues } toggleInput={ toggleIsChangeFormElementsActive } inputDisable={ inputDisable } queues={ queues } endpoints={ endpoints } />
      </div>
      <div  className="columns mx-2">
        <div id="button-send-form" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-active">
          <div className="control">
            <button className="button is-info is-fullwidth" type="submit" onClick={ () => sendDataDialplanInternal() } disabled={ disable }>
              <span>
                Criar Direcionamentos
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="columns mx-2">
        <div id="button-send-apply" className="column mt-3 is-half is-4 is-offset-4 has-text-centered is-hidden">
          <div className="control">
            <button className="button is-warning is-fullwidth" type="submit" onClick={ () => sendApplyConfig() }>
              <span>
                <strong>Aplicar</strong>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DialplanInternalCalls;
